import { FC, memo } from 'react';

import { Grid } from '@mui/material';

import { FormOptionsMenu } from './components/FormOptionsMenu/FormOptionsMenu';
import { FormTableHeader } from './components/FormTableHeader/FormTableHeader';
import { FormTableRow } from './components/FormTableRow';
import { IFormTable } from './types';

export const FormTable: FC<IFormTable> = memo(
  ({
    name,
    rows,
    columns,
    disabled,
    firstColumnWidth,
    defaultColumns = [],
    watchColumnTitleName = '',
    getDefaultColumnTitle,
    onInsertRow,
    onRemoveRow,
    notAllowedToDeleteRowIndexes,
    needToConvertToNegative,
    firstColumnLength,
  }) => {
    return (
      <Grid container gap={1.5}>
        <FormTableHeader
          defaultColumns={defaultColumns}
          firstColumnWidth={firstColumnWidth}
          watchColumnTitleName={watchColumnTitleName}
          getDefaultColumnTitle={getDefaultColumnTitle}
          columns={columns}
        />

        {rows.map((row, index) => (
          <Grid key={row.id} container display="flex" alignItems="center" gap={1} wrap="nowrap">
            <Grid item sx={{ width: 20, height: 20 }}>
              {!notAllowedToDeleteRowIndexes?.includes(index) && (
                <FormOptionsMenu
                  totalRowCount={rows.length}
                  rowIndex={index}
                  disabled={disabled}
                  onInsert={onInsertRow}
                  onRemove={onRemoveRow}
                />
              )}
            </Grid>
            <FormTableRow
              firstColumnLength={firstColumnLength}
              rowIndex={index}
              name={name}
              columns={columns}
              disabled={disabled}
              firstColumnWidth={firstColumnWidth}
              disabledNameColumn={notAllowedToDeleteRowIndexes?.includes(index) ?? false}
              needToConvertToNegative={needToConvertToNegative}
            />
          </Grid>
        ))}
      </Grid>
    );
  },
);
